<template>
  <ApexChart v-if="chartOption && chartOption.series && chartOption.series.length > 0" element="portFlowRateChart"
    :chartOption="chartOption" :series="chartOption.series" />
</template>

<script>
import moment from 'moment';

export default {
  name: 'PortFlowRateChart',
  props: {
    series: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartOption() {
      if (!this.series || this.series.length === 0) return null;

      const seriesData = this.series.length > 60 ? this.series.slice(-60) : this.series;

      const mappedData = seriesData.map((data) => {
        const raw = data && data.fmData && Number.isFinite(Number(data.fmData.PORT_InFlow))
          ? Number(data.fmData.PORT_InFlow) : null;
        return Number.isFinite(raw) ? Number(raw.toFixed(2)) : null;
      });

      const interpolatedData = this.interpolateNulls(mappedData);

      const chartSeries = [
        { name: 'Port Flow Rate', data: mappedData },
        { name: 'Port Flow Rate (Interpolated)', data: interpolatedData },
      ];

      return {
        series: chartSeries,
        chart: {
          height: 60,
          width: '100%',
          type: 'area',
          sparkline: {
            enabled: true,
          },
          group: 'sparklines',
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: 'smooth',
          dashArray: [0, 4], // Garis pertama solid, garis kedua putus-putus
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0,
          },
        },
        colors: ['#0084FF', 'rgba(0, 132, 255, 0.4)'],
        xaxis: {
          type: 'datetime',
          categories: seriesData.map((data) => moment(data.timestamp * 1000).format('DD MMMM YYYY HH:mm')),
        },
        tooltip: {
          enabled: true,
          custom({
            series, seriesIndex, dataPointIndex, w,
          }) {
            // Hanya tampilkan tooltip untuk data asli (seriesIndex 0) dan jika nilainya tidak null
            if (seriesIndex === 1 || series[seriesIndex][dataPointIndex] === null) {
              return '';
            }

            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex][dataPointIndex];
            const color = w.globals.colors[seriesIndex];
            const category = w.config.xaxis.categories[dataPointIndex];
            const title = moment(category, 'DD MMMM YYYY HH:mm').format('DD/MM/YY HH:mm');

            return `<div class="apexcharts-tooltip apexcharts-theme-light" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">
              <div class="apexcharts-tooltip-title" style="padding: 6px 10px;">
                ${title}
              </div>
              <div class="apexcharts-tooltip-series-group apexcharts-active" style="padding: 6px 10px; display: flex; align-items: center;">
                <span class="apexcharts-tooltip-marker" style="background-color: ${color}; width: 12px; height: 12px; margin-right: 10px; border-radius: 50%;"></span>
                <div class="apexcharts-tooltip-text">
                  <div class="apexcharts-tooltip-y-group">
                    <span class="apexcharts-tooltip-text-y-label">${seriesName}: </span>
                    <span class="apexcharts-tooltip-text-y-value">${value}</span>
                  </div>
                </div>
              </div>
            </div>`;
          },
        },
      };
    },
  },
  methods: {
    interpolateNulls(dataArray) {
      const result = [...dataArray];
      for (let i = 0; i < result.length; i++) {
        if (result[i] === null) {
          const startIndex = i - 1;
          const startValue = startIndex >= 0 ? result[startIndex] : null;

          if (startValue !== null) {
            let endIndex = -1;
            for (let j = i + 1; j < result.length; j++) {
              if (result[j] !== null) {
                endIndex = j;
                break;
              }
            }

            if (endIndex !== -1) {
              const endValue = result[endIndex];
              const gapCount = endIndex - startIndex;
              const totalDifference = endValue - startValue;
              const step = totalDifference / gapCount;

              for (let k = startIndex + 1; k < endIndex; k++) {
                const interpolatedValue = startValue + step * (k - startIndex);
                result[k] = Number(interpolatedValue.toFixed(2));
              }
              i = endIndex - 1;
            }
          }
        }
      }
      return result;
    },
  },
};
</script>
